import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import isLoggedIn from '../../../utils/auth';

import scrollToComponent from 'react-scroll-to-component';

import * as watchActionCreators from '../../../actions/watches';
let allActionCreators = Object.assign({}, watchActionCreators);





class Watches extends React.Component {

	constructor(props) {
		
    super(props);

    const PRICE_MIN = 0;
    const PRICE_MAX = 1000000;
    const COST_MIN = 0;
    const COST_MAX = 1000000;

    this.state = {

      brand: this.props.watches.watchFilter.brand && this.props.watches.watchFilter.brand.length > 0 ? this.props.watches.watchFilter.brand.split(',') : ['All'],
      size: this.props.watches.watchFilter.size && this.props.watches.watchFilter.size.length > 0 ? this.props.watches.watchFilter.size.split(',') : ['All'],

      movement: this.props.watches.watchFilter.movement && this.props.watches.watchFilter.movement.length > 0 ? this.props.watches.watchFilter.movement.split(',') : ['All'],
      crystal: this.props.watches.watchFilter.crystal && this.props.watches.watchFilter.crystal.length > 0 ? this.props.watches.watchFilter.crystal.split(',') : ['All'],
      dialColor: this.props.watches.watchFilter.dial_color && this.props.watches.watchFilter.dial_color.length > 0 ? this.props.watches.watchFilter.dial_color.split(',') : ['All'],
      caseMaterial: this.props.watches.watchFilter.case_material && this.props.watches.watchFilter.case_material.length > 0 ? this.props.watches.watchFilter.case_material.split(',') : ['All'],
      bandMaterial: this.props.watches.watchFilter.band_material && this.props.watches.watchFilter.band_material.length > 0 ? this.props.watches.watchFilter.band_material.split(',') : ['All'],

      assets: this.props.watches.watchFilter.assets && this.props.watches.watchFilter.assets.length > 0 ? this.props.watches.watchFilter.assets.split(',') : ['All'],
      searchTerm: this.props.watches.watchFilter.search_term ? this.props.watches.watchFilter.search_term : '',
      priceMin: this.props.watches.watchFilter.price_min && this.props.watches.watchFilter.price_min != PRICE_MIN ? this.props.watches.watchFilter.price_min : '',
      priceMax: this.props.watches.watchFilter.price_max && this.props.watches.watchFilter.price_max != PRICE_MAX ? this.props.watches.watchFilter.price_max : '',
      costMin: this.props.watches.watchFilter.cost_min && this.props.watches.watchFilter.cost_min != COST_MIN ? this.props.watches.watchFilter.cost_min : '',
      costMax: this.props.watches.watchFilter.cost_max && this.props.watches.watchFilter.cost_max != COST_MAX ? this.props.watches.watchFilter.cost_max : '',

      priceMinDefault: PRICE_MIN,
      priceMaxDefault: PRICE_MAX,
      costMinDefault: COST_MIN,
      costMaxDefault: COST_MAX,
    }

    // TODO: Remove any previous results
    // this.props.watchesSave(null);
	}

  userNav(page) {
    history.push('/' + page);
  }

  cloneArray(source) {
    let result = [];
    for(let n = 0; n < source.length; n++) {
      result[n] = source[n];
    }
    return result;
  }

  setBrand(brand) {
    if(brand === 'All') {
      this.setState({ brand: ['All'] });
      return;
    }
    if(this.state.brand.indexOf('All') > -1) {
      this.setState({ brand: [ brand ] });
      return;
    }

    let clone = this.cloneArray(this.state.brand);
    let i = this.state.brand.indexOf(brand);
    if(i === -1) {
      clone.push(brand);
      this.setState({ brand: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ brand: ['All'] });
      } else {
        this.setState({ brand: clone });
      }
    }
  }

  setSize(size) {
    if(size === 'All') {
      this.setState({ size: ['All'] });
      return;
    }
    if(this.state.size.indexOf('All') > -1) {
      this.setState({ size: [ size ] });
      return;
    }

    let clone = this.cloneArray(this.state.size);
    let i = this.state.size.indexOf(size);
    if(i === -1) {
      clone.push(size);
      this.setState({ size: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ size: ['All'] });
      } else {
        this.setState({ size: clone });
      }
    }
  }

  setMovement(movement) {
    if(movement === 'All') {
      this.setState({ movement: ['All'] });
      return;
    }
    if(this.state.movement.indexOf('All') > -1) {
      this.setState({ movement: [ movement ] });
      return;
    }

    let clone = this.cloneArray(this.state.movement);
    let i = this.state.movement.indexOf(movement);
    if(i === -1) {
      clone.push(movement);
      this.setState({ movement: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ movement: ['All'] });
      } else {
        this.setState({ movement: clone });
      }
    }
  }

  setCrystal(crystal) {
    if(crystal === 'All') {
      this.setState({ crystal: ['All'] });
      return;
    }
    if(this.state.crystal.indexOf('All') > -1) {
      this.setState({ crystal: [ crystal ] });
      return;
    }

    let clone = this.cloneArray(this.state.crystal);
    let i = this.state.crystal.indexOf(crystal);
    if(i === -1) {
      clone.push(crystal);
      this.setState({ crystal: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ crystal: ['All'] });
      } else {
        this.setState({ crystal: clone });
      }
    }
  }

  setDialColor(dialColor) {
    if(dialColor === 'All') {
      this.setState({ dialColor: ['All'] });
      return;
    }
    if(this.state.dialColor.indexOf('All') > -1) {
      this.setState({ dialColor: [ dialColor ] });
      return;
    }

    let clone = this.cloneArray(this.state.dialColor);
    let i = this.state.dialColor.indexOf(dialColor);
    if(i === -1) {
      clone.push(dialColor);
      this.setState({ dialColor: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ dialColor: ['All'] });
      } else {
        this.setState({ dialColor: clone });
      }
    }
  }

  setCaseMaterial(caseMaterial) {
    if(caseMaterial === 'All') {
      this.setState({ caseMaterial: ['All'] });
      return;
    }
    if(this.state.caseMaterial.indexOf('All') > -1) {
      this.setState({ caseMaterial: [ caseMaterial ] });
      return;
    }

    let clone = this.cloneArray(this.state.caseMaterial);
    let i = this.state.caseMaterial.indexOf(caseMaterial);
    if(i === -1) {
      clone.push(caseMaterial);
      this.setState({ caseMaterial: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ caseMaterial: ['All'] });
      } else {
        this.setState({ caseMaterial: clone });
      }
    }
  }

  setBandMaterial(bandMaterial) {
    if(bandMaterial === 'All') {
      this.setState({ bandMaterial: ['All'] });
      return;
    }
    if(this.state.bandMaterial.indexOf('All') > -1) {
      this.setState({ bandMaterial: [ bandMaterial ] });
      return;
    }

    let clone = this.cloneArray(this.state.bandMaterial);
    let i = this.state.bandMaterial.indexOf(bandMaterial);
    if(i === -1) {
      clone.push(bandMaterial);
      this.setState({ bandMaterial: clone });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ bandMaterial: ['All'] });
      } else {
        this.setState({ bandMaterial: clone });
      }
    }
  }

  changeSearchTerm(evt) {
    this.setState({ searchTerm: evt.target.value });
  }

  changePriceMin(evt) {
    this.setState({ priceMin: evt.target.value });
  }

  changePriceMax(evt) {
    this.setState({ priceMax: evt.target.value });
  }

  changeCostMin(evt) {
    this.setState({ costMin: evt.target.value });
  }

  changeCostMax(evt) {
    this.setState({ costMax: evt.target.value });
  }

  validatePriceMin(evt) {
    let minValue = parseInt(evt.target.value);
    let maxValue = this.state.priceMax === '' ? '' : parseInt(this.state.priceMax);

    if(isNaN(minValue)) { minValue = this.state.priceMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.priceMaxDefault }

    if(minValue < 0) {
      minValue = 0;
    }
    if(minValue > 1000000) {
      minValue = 1000000;
    }
    if(maxValue !== '' && maxValue < minValue) {
      maxValue = minValue;
    }
    this.setState({
      priceMin: minValue,
      priceMax: maxValue,
    });
  }

  validatePriceMax(evt) {
    let minValue = this.state.priceMin === '' ? '' : parseInt(this.state.priceMin);
    let maxValue = parseInt(evt.target.value);

    if(isNaN(minValue)) { minValue = this.state.priceMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.priceMaxDefault }

    if(maxValue < 0) {
      maxValue = 0;
    }
    if(maxValue > 1000000) {
      maxValue = 1000000;
    }
    if(minValue !== '' && maxValue < minValue) {
      minValue = maxValue;
    }
    this.setState({
      priceMin: minValue,
      priceMax: maxValue,
    });
  }

  validateCostMin(evt) {
    let minValue = parseInt(evt.target.value);
    let maxValue = this.state.costMax === '' ? '' : parseInt(this.state.costMax);

    if(isNaN(minValue)) { minValue = this.state.costMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.costMaxDefault }

    if(minValue < 0) {
      minValue = 0;
    }
    if(minValue > 1000000) {
      minValue = 1000000;
    }
    if(maxValue !== '' && maxValue < minValue) {
      maxValue = minValue;
    }
    this.setState({
      costMin: minValue,
      costMax: maxValue,
    });
  }

  validateCostMax(evt) {
    let minValue = this.state.costMin === '' ? '' : parseFloat(this.state.costMin);
    let maxValue = parseInt(evt.target.value);

    if(isNaN(minValue)) { minValue = this.state.costMinDefault }
    if(isNaN(maxValue)) { maxValue = this.state.costMaxDefault }

    if(maxValue < 0) {
      maxValue = 0;
    }
    if(maxValue > 1000000) {
      maxValue = 1000000;
    }
    if(minValue !== '' && maxValue < minValue) {
      minValue = maxValue;
    }
    this.setState({
      costMin: minValue,
      costMax: maxValue,
    });
  }

  scrollToAdvanced() {
    scrollToComponent(this.priceBlock, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  scrollToTop() {
    scrollToComponent(this.diamondMainBody, {
      offset: 0, 
      align: 'top', 
      duration: 1000, 
      ease: 'linear',
    });
  }

  createList(optionsArray) {

    let first = true;
    let optionList = '';

    if(optionsArray.length === 0) {
      return 'All';
    }

    for(let i = 0; i < optionsArray.length; i++) {
      if(first) {
        optionList = optionsArray[i];
      } else {
        optionList += ',' + optionsArray[i];
      }
      first = false;
    }
    return optionList;
  }

  resetSearch(evt) {

    evt.stopPropagation();

    this.setState({
      
      brand: ['All'],
      size: ['All'],

      searchTerm: '',

      priceMin: '',
      priceMax: '',
      costMin: '',
      costMax: '',
    }, () => {
      // TODO
      // this.props.setWatchFilters({});
      this.scrollToTop();
    })
  }

  handleSubmit() {

    const watchFilter = {
    //   carat_min: this.state.caratMin === '' ? this.state.caratMinDefault : this.state.caratMin,
    //   carat_max: this.state.caratMax === '' ? this.state.caratMaxDefault : this.state.caratMax,
      price_min: this.state.priceMin === '' ? this.state.priceMinDefault : this.state.priceMin,
      price_max: this.state.priceMax === '' ? this.state.priceMaxDefault : this.state.priceMax,
    //   cost_min: this.state.costMin === '' ? this.state.costMinDefault : this.state.costMin,
    //   cost_max: this.state.costMax === '' ? this.state.costMaxDefault : this.state.costMax,
    //   length_min: this.state.lengthMin === '' ? this.state.lengthMinDefault : this.state.lengthMin,
    //   length_max: this.state.lengthMax === '' ? this.state.lengthMaxDefault : this.state.lengthMax,
    //   width_min: this.state.widthMin === '' ? this.state.widthMinDefault : this.state.widthMin,
    //   width_max: this.state.widthMax === '' ? this.state.widthMaxDefault : this.state.widthMax,
    //   height_min: this.state.heightMin === '' ? this.state.heightMinDefault : this.state.heightMin,
    //   height_max: this.state.heightMax === '' ? this.state.heightMaxDefault : this.state.heightMax,

    //   table_min: this.state.tableMin === '' ? this.state.tableMinDefault : this.state.tableMin,
    //   table_max: this.state.tableMax === '' ? this.state.tableMaxDefault : this.state.tableMax,
    //   depth_min: this.state.depthMin === '' ? this.state.depthMinDefault : this.state.depthMin,
    //   depth_max: this.state.depthMax === '' ? this.state.depthMaxDefault : this.state.depthMax,
    //   ratio_min: this.state.ratioMin === '' ? this.state.ratioMinDefault : this.state.ratioMin,
    //   ratio_max: this.state.ratioMax === '' ? this.state.ratioMaxDefault : this.state.ratioMax,

    //   shape: this.createShapeList(this.state.shape),
      designers: this.createList(this.state.brand),
      movement: this.createList(this.state.movement),
      crystal: this.createList(this.state.crystal),
      dial_color: this.createList(this.state.dialColor),
      case_material: this.createList(this.state.caseMaterial),
      band_material: this.createList(this.state.bandMaterial),
    //   symmetry: this.createList(this.state.symmetry),
    //   flourescence: this.createList(this.state.flourescence),
    //   locations: this.createList(this.state.locations),
    //   assets: this.createList(this.state.assets),
    //   wallet: this.createList(this.state.wallet),

      // search_term: this.state.searchTerm,
    //   sort: 'price',

      page: 1,
    }

    if(this.state.searchTerm) {
      watchFilter['search_term'] = this.state.searchTerm;
    }

    this.props.setWatchFilters(watchFilter);
    history.push('watches/results');
  }

	render() {

		return <div className='Watches' ref={(div) => { this.diamondMainBody = div; }}>
			<div className={isLoggedIn() ? 'searchHeader loggedIn' : 'searchHeader'}>
        <div className='searchLabel'>Find the Perfect Timepiece</div>
        <div className='searchInput'>
          <input 
            type='text'
            placeholder='Search by SKU'
            value={this.state.searchTerm}
            onChange={this.changeSearchTerm.bind(this)} />
          <div className='searchIcon' onClick={this.handleSubmit.bind(this)}>
            <img src='/img/diamonds/magnify.svg' />
          </div>
        </div>
      </div>
      <div className='filterSection'>
        
        <div className='locationsBlock'>
          <div className='blockTitle'>Brand</div>
          <div className={'radioGroup locationRadio'}>
            <div 
              className={this.state.brand.includes('about') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('about')}>
              <div className='radioLabel'>About Time</div>
            </div>
            <div 
              className={this.state.brand.includes('alpina') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('alpina')}>
              <div className='radioLabel'>Alpina Frederique</div>
            </div>
            <div 
              className={this.state.brand.includes('arnold') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('arnold')}>
              <div className='radioLabel'>Arnold & Son USA</div>
            </div>
            <div 
              className={this.state.brand.includes('audemars') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('audemars')}>
              <div className='radioLabel'>Audemars Piguet</div>
            </div>
            <div 
              className={this.state.brand.includes('brm') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('brm')}>
              <div className='radioLabel'>B.R.M.</div>
            </div>
            <div 
              className={this.state.brand.includes('blancpain') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('blancpain')}>
              <div className='radioLabel'>Blancpain</div>
            </div>
            <div 
              className={this.state.brand.includes('casio') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('casio')}>
              <div className='radioLabel'>Casio</div>
            </div>
            <div 
              className={this.state.brand.includes('denovo') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('denovo')}>
              <div className='radioLabel'>Denovo</div>
            </div>
            <div 
              className={this.state.brand.includes('ecj') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('ecj')}>
              <div className='radioLabel'>ECJ Luxe</div>
            </div>
            <div 
              className={this.state.brand.includes('envoy') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('envoy')}>
              <div className='radioLabel'>Envoy Trading</div>
            </div>
            <div 
              className={this.state.brand.includes('ernst') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('ernst')}>
              <div className='radioLabel'>Ernst Benz USA</div>
            </div>
            <div 
              className={this.state.brand.includes('franck-muller') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('franck-muller')}>
              <div className='radioLabel'>Franck Muller</div>
            </div>
            <div 
              className={this.state.brand.includes('glashutte') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('glashutte')}>
              <div className='radioLabel'>Glashutte</div>
            </div>
            <div 
              className={this.state.brand.includes('gruppo') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('gruppo')}>
              <div className='radioLabel'>Gruppo Gamma</div>
            </div>
            <div 
              className={this.state.brand.includes('hublot') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('hublot')}>
              <div className='radioLabel'>Hublot</div>
            </div>
            <div 
              className={this.state.brand.includes('hyt') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('hyt')}>
              <div className='radioLabel'>HYT Americas INC</div>
            </div>
            <div 
              className={this.state.brand.includes('kb2') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('kb2')}>
              <div className='radioLabel'>KB2</div>
            </div>
            <div 
              className={this.state.brand.includes('louis-moinet') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('louis-moinet')}>
              <div className='radioLabel'>Louis Moinet</div>
            </div>
            <div 
              className={this.state.brand.includes('lacroix') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('lacroix')}>
              <div className='radioLabel'>Maurice LaCroix</div>
            </div>
            <div 
              className={this.state.brand.includes('ocean') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('ocean')}>
              <div className='radioLabel'>Ocean Crawler LLC</div>
            </div>
            <div 
              className={this.state.brand.includes('perrelet') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('perrelet')}>
              <div className='radioLabel'>Perrelet</div>
            </div>
            <div 
              className={this.state.brand.includes('rolex') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('rolex')}>
              <div className='radioLabel'>Rolex</div>
            </div>
            <div 
              className={this.state.brand.includes('rw') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('rw')}>
              <div className='radioLabel'>RW USA Corp</div>
            </div>
            <div 
              className={this.state.brand.includes('sablier') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('sablier')}>
              <div className='radioLabel'>Sablier</div>
            </div>
            <div 
              className={this.state.brand.includes('tockr') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('tockr')}>
              <div className='radioLabel'>Tockr LLC</div>
            </div>
            <div 
              className={this.state.brand.includes('u-boat') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('u-boat')}>
              <div className='radioLabel'>U-Boat</div>
            </div>
            <div 
              className={this.state.brand.includes('zenith') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('zenith')}>
              <div className='radioLabel'>Zenith</div>
            </div>
            <div 
              className={this.state.brand.indexOf('All') > -1 ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBrand('All')}>
              <div className='radioLabel'>All</div>
            </div>
          </div>
        </div>
        
        <div className='colorBlock' style={{ display: 'none' }}>
          <div className='blockTitle'>Size</div>
          <div className={'radioGroup leftGroup secondColor'}>
            <div 
              className={this.state.size.includes('S') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setSize('S')}>
              <div className='radioLabel'>S</div>
            </div>
            <div 
              className={this.state.size.includes('M') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setSize('M')}>
              <div className='radioLabel'>M</div>
            </div>
            <div 
              className={this.state.size.includes('L') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setSize('L')}>
              <div className='radioLabel'>L</div>
            </div>
            <div 
              className={this.state.size.includes('XL') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setSize('XL')}>
              <div className='radioLabel'>XL</div>
            </div>
            <div 
              className={this.state.size.includes('All') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setSize('All')}>
              <div className='radioLabel'>All</div>
            </div>
          </div>
        </div>

        <div className='colorBlock'>
          <div className='blockTitle'>Movement</div>
          <div className={'radioGroup leftGroup secondColor'}>
            <div 
              className={this.state.movement.includes('Automatic') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setMovement('Automatic')}>
              <div className='radioLabel'>Automatic</div>
            </div>
            <div 
              className={this.state.movement.includes('Electric') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setMovement('Electric')}>
              <div className='radioLabel'>Electric</div>
            </div>
            <div 
              className={this.state.movement.includes('Kinetic') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setMovement('Kinetic')}>
              <div className='radioLabel'>Kinetic</div>
            </div>
            <div 
              className={this.state.movement.includes('Mechanical') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setMovement('Mechanical')}>
              <div className='radioLabel'>Mechanical</div>
            </div>
            <div 
              className={this.state.movement.includes('Quartz') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setMovement('Quartz')}>
              <div className='radioLabel'>Quartz</div>
            </div>
            <div 
              className={this.state.movement.includes('Solar') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setMovement('Solar')}>
              <div className='radioLabel'>Solar</div>
            </div>
            <div 
              className={this.state.movement.includes('Tuning') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setMovement('Tuning')}>
              <div className='radioLabel'>Tuning</div>
            </div>
            <div 
              className={this.state.movement.includes('Other') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setMovement('Other')}>
              <div className='radioLabel'>Other</div>
            </div>
            <div 
              className={this.state.movement.includes('All') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setMovement('All')}>
              <div className='radioLabel'>All</div>
            </div>
          </div>
        </div>

        <div className='colorBlock'>
          <div className='blockTitle'>Crystal</div>
          <div className={'radioGroup leftGroup secondColor'}>
            <div 
              className={this.state.crystal.includes('Acrylic') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setCrystal('Acrylic')}>
              <div className='radioLabel'>Acrylic</div>
            </div>
            <div 
              className={this.state.crystal.includes('Glass') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setCrystal('Glass')}>
              <div className='radioLabel'>Glass</div>
            </div>
            <div 
              className={this.state.crystal.includes('Mineral') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setCrystal('Mineral')}>
              <div className='radioLabel'>Mineral</div>
            </div>
            <div 
              className={this.state.crystal.includes('Plastic') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setCrystal('Plastic')}>
              <div className='radioLabel'>Plastic</div>
            </div>
            <div 
              className={this.state.crystal.includes('Sapphire') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setCrystal('Sapphire')}>
              <div className='radioLabel'>Sapphire</div>
            </div>
            <div 
              className={this.state.crystal.includes('Other') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setCrystal('Other')}>
              <div className='radioLabel'>Other</div>
            </div>
            <div 
              className={this.state.crystal.includes('All') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setCrystal('All')}>
              <div className='radioLabel'>All</div>
            </div>
          </div>
        </div>

        <div className='colorBlock'>
          <div className='blockTitle'>Dial Color</div>
          <div className={'radioGroup leftGroup secondColor'}>
            <div 
              className={this.state.dialColor.includes('Blue') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Blue')}>
              <div className='radioLabel'>Blue</div>
            </div>
            <div 
              className={this.state.dialColor.includes('Bronze') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Bronze')}>
              <div className='radioLabel'>Bronze</div>
            </div>
            <div 
              className={this.state.dialColor.includes('Brown') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Brown')}>
              <div className='radioLabel'>Brown</div>
            </div>
            <div 
              className={this.state.dialColor.includes('Champagne') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Champagne')}>
              <div className='radioLabel'>Champagne</div>
            </div>
            <div 
              className={this.state.dialColor.includes('Gray') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Gray')}>
              <div className='radioLabel'>Gray</div>
            </div>
            <div 
              className={this.state.dialColor.includes('Green') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Green')}>
              <div className='radioLabel'>Green</div>
            </div>
            <div 
              className={this.state.dialColor.includes('Ivory') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Ivory')}>
              <div className='radioLabel'>Ivory</div>
            </div>
            <div 
              className={this.state.dialColor.includes('Meteorite') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Meteorite')}>
              <div className='radioLabel'>Meteorite</div>
            </div>
            <div 
              className={this.state.dialColor.includes('MOP') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('MOP')}>
              <div className='radioLabel'>MOP</div>
            </div>
            <div 
              className={this.state.dialColor.includes('Orange') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Orange')}>
              <div className='radioLabel'>Orange</div>
            </div>
            <div 
              className={this.state.dialColor.includes('Pink') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Pink')}>
              <div className='radioLabel'>Pink</div>
            </div>
            <div 
              className={this.state.dialColor.includes('Purple') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Purple')}>
              <div className='radioLabel'>Purple</div>
            </div>
            <div 
              className={this.state.dialColor.includes('Red') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Red')}>
              <div className='radioLabel'>Red</div>
            </div>
            <div 
              className={this.state.dialColor.includes('Silver') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Silver')}>
              <div className='radioLabel'>Silver</div>
            </div>
            <div 
              className={this.state.dialColor.includes('Skeleton') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Skeleton')}>
              <div className='radioLabel'>Skeleton</div>
            </div>
            <div 
              className={this.state.dialColor.includes('Slate') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Slate')}>
              <div className='radioLabel'>Slate</div>
            </div>
            <div 
              className={this.state.dialColor.includes('White') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('White')}>
              <div className='radioLabel'>White</div>
            </div>
            <div 
              className={this.state.dialColor.includes('Yellow') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('Yellow')}>
              <div className='radioLabel'>Yellow</div>
            </div>
            <div 
              className={this.state.dialColor.includes('All') ? 'radioBlock longBlock selected' : 'radioBlock longBlock'}
              onClick={() => this.setDialColor('All')}>
              <div className='radioLabel'>All</div>
            </div>
          </div>
        </div>

        <div className='colorBlock'>
          <div className='blockTitle'>Case Material</div>
          <div className={'radioGroup leftGroup secondColor'}>
            <div 
              className={this.state.caseMaterial.includes('14ct') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setCaseMaterial('14ct')}>
              <div className='radioLabel'>14ct Gold</div>
            </div>
            <div 
              className={this.state.caseMaterial.includes('Platinum') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setCaseMaterial('Platinum')}>
              <div className='radioLabel'>Platinum</div>
            </div>
            <div 
              className={this.state.caseMaterial.includes('Rubber') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setCaseMaterial('Rubber')}>
              <div className='radioLabel'>Rubber</div>
            </div>
            <div 
              className={this.state.caseMaterial.includes('Steel') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setCaseMaterial('Steel')}>
              <div className='radioLabel'>Stainless Steel</div>
            </div>
            <div 
              className={this.state.caseMaterial.includes('Titanium') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setCaseMaterial('Titanium')}>
              <div className='radioLabel'>Titanium</div>
            </div>
            <div 
              className={this.state.caseMaterial.includes('Ceramic') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setCaseMaterial('Ceramic')}>
              <div className='radioLabel'>Ceramic</div>
            </div>
            <div 
              className={this.state.caseMaterial.includes('18kRose') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setCaseMaterial('18kRose')}>
              <div className={'radioLabel extraText'}>18ct Rose Gold</div>
            </div>
            <div 
              className={this.state.caseMaterial.includes('18kWhite') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setCaseMaterial('18kWhite')}>
              <div className={'radioLabel extraText'}>18ct White Gold</div>
            </div>
            <div 
              className={this.state.caseMaterial.includes('18kYellow') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setCaseMaterial('18kYellow')}>
              <div className={'radioLabel extraText'}>18ct Yellow Gold</div>
            </div>
            <div 
              className={this.state.caseMaterial.includes('other') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setCaseMaterial('other')}>
              <div className='radioLabel'>Other</div>
            </div>

            <div 
              className={this.state.caseMaterial.includes('All') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setCaseMaterial('All')}>
              <div className='radioLabel'>All</div>
            </div>
          </div>
        </div>

        <div className='colorBlock'>
          <div className='blockTitle'>Band Material</div>
          <div className={'radioGroup leftGroup secondColor'}>
            <div 
              className={this.state.bandMaterial.includes('Calf') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBandMaterial('Calf')}>
              <div className='radioLabel'>Calf</div>
            </div>
            <div 
              className={this.state.bandMaterial.includes('Crocodile') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBandMaterial('Crocodile')}>
              <div className='radioLabel'>Crocodile</div>
            </div>
            <div 
              className={this.state.bandMaterial.includes('GrossGrain') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBandMaterial('GrossGrain')}>
              <div className='radioLabel'>Gross Grain</div>
            </div>
            <div 
              className={this.state.bandMaterial.includes('Leather') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBandMaterial('Leather')}>
              <div className='radioLabel'>Leather</div>
            </div>
            <div 
              className={this.state.bandMaterial.includes('Lizard') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBandMaterial('Lizard')}>
              <div className='radioLabel'>Lizard</div>
            </div>
            <div 
              className={this.state.bandMaterial.includes('Metal') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBandMaterial('Metal')}>
              <div className='radioLabel'>Metal</div>
            </div>
            <div 
              className={this.state.bandMaterial.includes('Ostrich') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBandMaterial('Ostrich')}>
              <div className='radioLabel'>Ostrich</div>
            </div>
            <div 
              className={this.state.bandMaterial.includes('Rubber') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBandMaterial('Rubber')}>
              <div className='radioLabel'>Rubber</div>
            </div>
            <div 
              className={this.state.bandMaterial.includes('Satin') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBandMaterial('Satin')}>
              <div className='radioLabel'>Satin</div>
            </div>
            <div 
              className={this.state.bandMaterial.includes('Shark') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBandMaterial('Shark')}>
              <div className='radioLabel'>Shark</div>
            </div>
            <div 
              className={this.state.bandMaterial.includes('Stingray') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBandMaterial('Stingray')}>
              <div className='radioLabel'>Stingray</div>
            </div>
            <div 
              className={this.state.bandMaterial.includes('Other') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBandMaterial('Other')}>
              <div className='radioLabel'>Other</div>
            </div>
            <div 
              className={this.state.bandMaterial.includes('All') ? 'radioBlock selected' : 'radioBlock'}
              onClick={() => this.setBandMaterial('All')}>
              <div className='radioLabel'>All</div>
            </div>
          </div>
        </div>

        <div className='priceBlock' ref={(div) => { this.priceBlock = div; }}>
          <div className='blockTitle'>Price</div>
          <div className='rangeWrapper'>
            <div className='rangeInput'>
              <input 
                className='rangeElement'
                placeholder='0'
                type='number'
                value={this.state.priceMin}
                onChange={this.changePriceMin.bind(this)}
                onBlur={this.validatePriceMin.bind(this)}
                min={0}
                max={this.state.priceMax}
                step={1} />
            </div>
            <div className='rangeTo'>to</div>
            <div className='rangeInput'>
              <input 
                className='rangeElement' 
                placeholder='1,000,000'
                type='number'
                value={this.state.priceMax}
                onChange={this.changePriceMax.bind(this)}
                onBlur={this.validatePriceMax.bind(this)}
                min={this.state.priceMin}
                max={1000000}
                step={1} />
            </div>
          </div>
        </div>
        {isLoggedIn() ?
          <div className='costBlock' ref={(div) => { this.costBlock = div; }}>
            <div className='blockTitle'>Cost</div>
            <div className='rangeWrapper'>
              <div className='rangeInput'>
                <input 
                  className='rangeElement'
                  placeholder='0'
                  type='number'
                  value={this.state.costMin}
                  onChange={this.changeCostMin.bind(this)}
                  onBlur={this.validateCostMin.bind(this)}
                  min={0}
                  max={this.state.costMax}
                  step={1} />
              </div>
              <div className='rangeTo'>to</div>
              <div className='rangeInput'>
                <input 
                  className='rangeElement' 
                  placeholder='1,000,000'
                  type='number'
                  value={this.state.costMax}
                  onChange={this.changeCostMax.bind(this)}
                  onBlur={this.validateCostMax.bind(this)}
                  min={this.state.costMin}
                  max={1000000}
                  step={1} />
              </div>
            </div>
          </div> :
          null
        }
      </div>
      <div className={'searchSubmit bottomAction refreshIcon'} onClick={this.handleSubmit.bind(this)} style={{ marginTop: '30px' }}>
        Search
        <div className='iconWrapper' onClick={this.resetSearch.bind(this)}>
          <img src='/img/icons/reset.svg' />
        </div>
      </div>
		</div>;
	}
}
export default Watches;

function mapStateToProps(state) {
  return {
    watches: state.watches,
  };
}

export const WatchesContainer = connect(
  mapStateToProps,
  allActionCreators
)(Watches);